module.exports = __webpack_public_path__ + "img/Paradart.1ea9bc79.jpg";